export interface GradientConfig {
    deg: number;
    from: string;
    to: string;
}

export const DEFAULT_GRADIENT_FROM = "#667eea";
export const DEFAULT_GRADIENT_TO = "#764ba2";
export const DEFAULT_GRADIENT_DEG = 135;

export function buildGradientString(from: string, to: string, deg: number): string {
    return `linear-gradient(${deg}deg, ${from} 0%, ${to} 100%)`;
}

export function parseGradientString(val?: string | null): GradientConfig {
    const defaultVal: GradientConfig = {
        deg: DEFAULT_GRADIENT_DEG,
        from: DEFAULT_GRADIENT_FROM,
        to: DEFAULT_GRADIENT_TO,
    };

    if (!val || typeof val !== "string") return defaultVal;

    const match = val.match(/linear-gradient\s*\((.*)\)/i);
    if (!match) return defaultVal;

    const inner = match[1].trim();
    const parts: string[] = [];
    let depth = 0;
    let current = "";
    for (let i = 0; i < inner.length; i++) {
        const char = inner[i];
        if (char === "(") depth++;
        else if (char === ")") depth--;

        if (char === "," && depth === 0) {
            parts.push(current.trim());
            current = "";
        } else {
            current += char;
        }
    }
    if (current.trim()) {
        parts.push(current.trim());
    }

    if (parts.length < 2) return defaultVal;

    let deg = DEFAULT_GRADIENT_DEG;
    let colorParts = parts;

    const firstPart = parts[0].toLowerCase();
    const degMatch = firstPart.match(/^(\d+(?:\.\d+)?)deg$/);
    if (degMatch) {
        deg = Math.round(parseFloat(degMatch[1])) % 360;
        colorParts = parts.slice(1);
    } else if (firstPart.startsWith("to ")) {
        if (firstPart === "to top") deg = 0;
        else if (firstPart === "to right") deg = 90;
        else if (firstPart === "to bottom") deg = 180;
        else if (firstPart === "to left") deg = 270;
        else if (firstPart === "to top right" || firstPart === "to right top") deg = 45;
        else if (firstPart === "to bottom right" || firstPart === "to right bottom") deg = 135;
        else if (firstPart === "to bottom left" || firstPart === "to left bottom") deg = 225;
        else if (firstPart === "to top left" || firstPart === "to left top") deg = 315;
        colorParts = parts.slice(1);
    }

    if (colorParts.length >= 2) {
        const stripStop = (c: string) => c.replace(/\s+\d+%\s*$/, "").trim();
        const from = stripStop(colorParts[0]) || DEFAULT_GRADIENT_FROM;
        const to = stripStop(colorParts[colorParts.length - 1]) || DEFAULT_GRADIENT_TO;
        return { deg, from, to };
    }

    return defaultVal;
}
